import * as Sentry from '@sentry/nextjs';
import Script from 'next/script';
import { getMoengageInitScriptSrc, shouldInitializeMoengage } from '@/utils/moengage';
const MoengageScripts = () => {
  if (!shouldInitializeMoengage()) return null;
  return <Script strategy="lazyOnload" id="moengage-init" src={getMoengageInitScriptSrc()} onError={() => {
    Sentry.captureMessage('MoEngage init script failed to load', {
      level: 'error'
    });
  }} data-sentry-element="Script" data-sentry-component="MoengageScripts" data-sentry-source-file="MoengageScripts.tsx" />;
};
export default MoengageScripts;